import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import './element-ui.scss'

Vue.use(ElementUI, { locale })
